
// https://tabler.io/icons


import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NavItem } from './nav-item/nav-item';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NavItemService {
  private navItems: NavItem[] = [
    {
      displayName: 'MENU_NAV_CAP.API_KEY',
      iconName: 'key',
      route: '/apikeys',
      permissions: ['user']
    },
    {
      displayName: 'MENU_NAV_CAP.ACCOUNT',
      iconName: 'user-circle',
      route: '/account',
      permissions: ['user', 'admin']
    },

    { navCap: 'MENU_NAV_CAP.BILLING' },
    {
      displayName: 'MENU_NAV_CAP.PLAN',
      iconName: 'badge',
      route: '/billing/plan',
      permissions: ['user']
    },
    {
      displayName: 'MENU_NAV_CAP.PAYMENT_METHOD',
      iconName: 'wallet',
      route: '/billing/payment-method',
      permissions: ['user']
    },
    {
      displayName: 'MENU_NAV_CAP.INVOICE',
      iconName: 'receipt',
      route: '/billing/invoice',
      permissions: ['user']
    },

    {
      navCap: 'MENU_NAV_CAP.ADMIN',
      permissions: ['admin'],
    },
    {
      displayName: 'MENU_NAV_CAP.ADMIN_INVOICE_REQUESTED',
      iconName: 'user',
      route: '/admin/invoice-requested',
      permissions: ['admin'],
    },

    // {
    //   displayName: 'MENU_NAV_CAP.ADMIN_USERS',
    //   iconName: 'users',
    //   route: '/admin/users',
    //   permissions: ['admin'],
    // },
    // {
    //   displayName: 'MENU_NAV_CAP.ADMIN_PLANS',
    //   iconName: 'user',
    //   route: '/admin/plans',
    //   permissions: ['admin'],
    // },

    
    { navCap: 'MENU_NAV_CAP.RESOURCE' },
    {
      displayName: 'MENU_NAV_CAP.API_DOC',
      iconName: 'external-link',
      href: 'apikeyDocumentUrl',
      permissions: ['user', 'admin']
    },
    {
      displayName: 'MENU_NAV_CAP.CONTACT',
      iconName: 'external-link',
      href: '/contact',
    },
    {
      displayName: 'MENU_NAV_CAP.TERM',
      iconName: 'external-link',
      href: '/term',
    },
    {
      displayName: 'MENU_NAV_CAP.PRIVACY',
      iconName: 'external-link',
      href: '/privacy',
    },
  ];

  constructor(private translate: TranslateService) { }

  async getTranslatedNavItems(): Promise<NavItem[]> {
    return Promise.all(
      this.navItems.map(async (item) => {
        const translatedName = await firstValueFrom(this.translate.get([item.displayName!, item.navCap!]));
        return { ...item, displayName: translatedName[item.displayName!], navCap: translatedName[item.navCap!] };
      })
    );
  }
}
